import axios from "axios";
import { apiURL } from "../config/default";
import setAuthHeader from "../utils/setAuthHeader";

export const currentLocation = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    if (token) {
      const res = await axios.get(`${apiURL}address-books`);

      if (res.data && res.data.length !== 0) {
        // console.log(res.data[0]);
        localStorage.setItem("location", JSON.stringify(res.data[0]));
        // const res = await axios.get(`http://ip-api.com/json`, _config);

        // localStorage.setItem("location", JSON.stringify(res.data));
        // return res;
      } else {
        const location = await axios.get(`http://ip-api.com/json`, _config);

        localStorage.setItem("location", JSON.stringify(location.data));
      }
    } else {
      const location = await axios.get(`http://ip-api.com/json`, _config);

      localStorage.setItem("location", JSON.stringify(location.data));
    }
  } catch (err) {
    console.log(err.response.data.error);
  }
};
